import React, { Component } from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import MoviesMediaUI from '../CommonComponents/MoviesMediaUI';

class MoviesPageComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleMovie: true
        }
    }

    showContentMovie = data => {
        let result = [];
        let list_movies = [];
        let { toggleMovie } = this.state;
        if (data) {
            list_movies = toggleMovie ? data.medias : data.hot_medias;
            if (list_movies.length) {
                for (let indexMovie in list_movies) {
                    result.push(
                        <Link to={ '/media/watch/' + list_movies[indexMovie].id } key={ indexMovie } >
                            <MoviesMediaUI dataMedias={ list_movies[indexMovie] } />
                        </Link>
                    );
                }
            }
        }
        return result.length ? result : <span className="text-center">Không có phim nào trong danh sách</span>;
    }

    onToggleMovie = (param) => {
        let toggleMovie = param === -1 ? true : false;
        if (param !== this.state.toggleMovie) {
            this.setState({
                toggleMovie
            });
        }
    }

    render() {

        let settingsSlickMovies = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToScroll: 8,
            slidesToShow: 8,
            responsive: [
                {
                    breakpoint: 1650,
                    settings: {
                      slidesToShow: 6,
                      slidesToScroll: 6,
                      dots: true
                    }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
        };

        let { dataCategories } = this.props;
        let { toggleMovie } = this.state;

        return (
            dataCategories ?
            <div className="block-index-movie">
                <div className="container" style={{ padding: 0 }}>
                    <div className="block-index">
                            <div className="block-index-movie">
                                <div className="container">
                                    <div className="title clearfix text-blue">
                                    <Link to={`trang-phim/${dataCategories._id}/${dataCategories.slug}`} className="main">{ dataCategories.name } /</Link>
                                    <a
                                        className={ toggleMovie ? 'sub-main-active' : 'sub-main' }
                                        onClick={ () => this.onToggleMovie(-1) }
                                    >Phim mới</a>
                                    <a
                                        className={ !toggleMovie ? 'sub-main-active' : 'sub-main' }
                                        onClick={ () => this.onToggleMovie(1) }
                                    >Phim hot</a>
                                    </div>
                                    <div className="index-movie-slick block-index-common">
                                        <Slider {...settingsSlickMovies}>
                                            { this.showContentMovie(dataCategories) }
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            : <div className="container"><p className="text-center">Không có nội dung!</p></div>
        );
    }

}

export default MoviesPageComponent;



// WEBPACK FOOTER //
// ./src/components/MoviePageComponent/MoviesPageComponent.js